module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.fileName) ? _c('div', [_c('i', [_vm._v(_vm._s(_vm.text) + " not available")])]) : _c('div', [_c('strong', [_c('a', {
    staticClass: "el-button",
    attrs: {
      "href": _vm.url,
      "download": _vm.fileName
    }
  }, [_c('i', {
    class: 'el-icon-' + _vm.icon
  }), _vm._v(_vm._s(_vm.text) + " - " + _vm._s(_vm.fileName) + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7029981c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/files/FileDownload.vue
// module id = 1632
// module chunks = 0